import React, { useRef } from 'react'
import Header from '../../components/Header'
import { Button } from '@mui/material'
import { ApiLoginUser } from '../../Api'
import './style.css'
import Footer from '../../components/Footer'
import { useUserStorage } from '../../storage/user'
import { useNavigate } from 'react-router-dom'
import { notify } from '../../components/Notify'
import { mockAlunoApi } from '../../mock'
import Cookies from "js-cookie";
import logintake from '../../assets/logintake.jpg'
import { useGlobalCarteira } from '../../storage/globalCarteira'
import { removerImagemLocal } from '../../storage/indexedDbService'

export default function Login() {


    const { user, dispatch } = useUserStorage(state => state)
    const { setDataCarteira } = useGlobalCarteira(state => state)
    const navigate = useNavigate();

    const cpf = useRef(null)
    const password = useRef(null)

    const login = async () => {

        const expirationTime = 1 /* new Date(new Date().getTime() + 15 * 1000) */;

        const payload = {
            userEmail: cpf?.current?.trim(),
            userPassword: password?.current?.trim(),
        };


        if (!cpf.current || !password.current) {
            return notify('Preencha os campos!')
        }

        console.log('1')
        await removerImagemLocal('imagemUser')


        ApiLoginUser(payload).then(res => {
            console.log('2')
            if (res.data.auth == false) {
                return notify(res.data.message)
            }

            console.log('3')


            /* if(res.data.message) */
            Cookies.set("login", "true", { expires: expirationTime })

            localStorage.setItem("token", res.data.token);
            localStorage.setItem("temCarteira", true);
            localStorage.setItem("id", res.data.usuario_id);
            dispatch.setTipoEstudante(res?.data?.tipo)
            if (res?.data?.tipo === 'ADMINISTRADOR' || res?.data?.tipo === 'FUNCIONARIO') {
                localStorage.setItem("user", null);
                localStorage.setItem("nome", res?.data?.nome);
                localStorage.setItem("user_id", res?.data?.user_id);
                localStorage.setItem("tipo", res?.data?.tipo);
                navigate("/cadastrarCarteira");
            } else {
                Cookies.set("imagem", "false", { expires: expirationTime })
                localStorage.setItem("tipo", 'ESTUDANTE');
                const stringObjUser = JSON.stringify(res.data);
                localStorage.setItem("user", stringObjUser);
                dispatch.setUser(res.data)
                setDataCarteira(res.data)
                navigate("/painel");
            }


        }).catch(err => {
            if (err.response.data.message === "Bad credentials") {
                return notify('Login ou senha inválida!')
            }
            return notify(err.response.data.message)
        })
    }

    return (
        <div>
            <Header />
            <div className='backgroundLogin' style={{ width: '100%', height: '500px', display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                <div style={{ padding: '0 20px', background: 'white', height: '450px', width: '350px', borderRadius: '5px', flexDirection: 'column', display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>

                    {/*  <img src={logintake} width={150} />
                    <div className='linha' /> */}
                    <h1 style={{ fontSize: '24px', alignSelf: 'start' }}>Login</h1>

                    <div style={{ width: '100%', textAlign: 'center' }}>

                        <input
                            style={{ padding: '0 0 0 10px', outline: 'none', marginBottom: '25px', height: '38px', width: '340px', borderRadius: '5px', margin: '10px 0px', border: '1px solid #dddddd' }}
                            error={false}
                            placeholder="Email"
                            onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                    login()
                                }
                            }
                            }
                            onChange={(e) => {
                                cpf.current = e.target.value
                            }}
                        />

                        <input
                            style={{ padding: '0 0 0 10px', outline: 'none', marginBottom: '25px', height: '38px', width: '340px', borderRadius: '5px', margin: '10px 0px', border: '1px solid #dddddd' }}
                            error={false}
                            onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                    login()
                                }
                            }
                            }
                            type="password"
                            placeholder="Senha"
                            onChange={(e) => { password.current = e.target.value }}
                        />
                    </div>

                    <Button style={{ width: '346px', background: '#fd7628' }} variant="contained" onClick={login}>Acessar</Button>

                </div>


            </div>
            <Footer />
        </div>
    )
}
